import { localeSetActions, localeUpdateActions } from './index.js'
import appActions from 'Actions/appActions'
import Locale from 'Services/locale'
import translationsLoader from 'Services/http/translationsLoader'
import MarketsSvc from 'Services/markets/marketsSvc'
import Countries from 'Services/http/countries'
//NOTE: get actions can run more than once.
//They use an Ajax call or the current ${getState()} to retrieve data.
//get actions dispatch additonal get actions or set actions only
const localeGetActions = (function () {
    const actions = {
        getMarketCurrency: () => {
            return (dispatch, getState) => {
                let { country, markets } = getState().locale
                let marketCurrency = MarketsSvc.getMarketCurrency(markets, country)
                dispatch(localeSetActions.setMarketCurrency(marketCurrency))
            }
        },
        getDefaultLanguage: () => {
            return (dispatch, getState) => {
                let { country, markets } = getState().locale
                let language = Locale.getDefaultLanguage(markets, country)
                let preLoadedLanguage = getState().locale.language
                if (preLoadedLanguage) {
                    language = preLoadedLanguage
                }
                dispatch(localeSetActions.setLanguage(language))
            }
        },
        getLocale: () => {
            return (dispatch, getState) => {
                let { country, language, markets } = getState().locale
                let locale = Locale.createLocale(country, language)
                dispatch(localeSetActions.setLocale(locale))
                dispatch(appActions.setCatalogName(country))
                let catalogType = MarketsSvc.getCatalogType(markets, country)
                dispatch(appActions.setCatalogType(catalogType))
                dispatch(actions.getTranslations(locale))
            }
        },
        getTranslations: () => {
            return async (dispatch, getState) => {
                dispatch(appActions.setIsLoading(true))
                let { locale } = getState().locale
                let translationLocale = Locale.getTranslationLocale(locale)
                translationsLoader
                    .get(translationLocale)
                    .then((translations) => {
                        // console.log('locale success')
                        dispatch(localeSetActions.setTranslations(translations))
                    })
                    .fail(() => {
                        console.log('locale fail')
                        dispatch(appActions.setIsLoading(false))
                    })
                    .finally(() => {
                        dispatch(appActions.setIsLoading(false))
                    })
            }
        },
        getLangOptions: () => {
            return (dispatch, getState) => {
                let { country, markets } = getState().locale
                let availableLanguages = Locale.getLangOptions(markets, country)
                dispatch(localeSetActions.setLangOptions(availableLanguages))
            }
        },
        getShippingMethods: () => {
            return (dispatch, getState) => {
                Countries.getShippingMethods(getState().locale.country).then((shippingMethods) => {
                    dispatch(localeSetActions.setShippingMethods(shippingMethods))
                    dispatch(localeUpdateActions.filterShippingMethods())
                })
            }
        },
        getCountryRegions: () => {
            return (dispatch, getState) => {
                Countries.getRegions(getState().locale.country).done((regions) => {
                    dispatch(localeSetActions.setRegions(regions))
                })
            }
        },
    }
    return actions
})()

export default localeGetActions



// WEBPACK FOOTER //
// ./src/store/actions/localeActions/localeGetActions.js